import { Dayjs } from "dayjs";

/**
 * Enum for transport mode types
 */
export enum TransportMode {
	Road = "road",
	Train = "train",
	Sea = "sea",
	Air = "air",
	Water = "water",
}

/**
 * Enum for temperature types
 */
export enum TemperatureType {
	Ambient = "ambient",
	Controlled = "controlled",
	Fresh = "fresh",
	Frozen = "frozen",
	Refrigerated = "refrigerated",
}

/**
 * Enum for calculation modes
 */
export enum CalculationMode {
	Mixed = "mixed",
	Dedicated = "dedicated",
}

/**
 * Enum for weight units
 */
export enum WeightUnit {
	Tonne = "tonne",
	Kg = "kg",
	Teu = "teu",
}

/**
 * Enum for distance units
 */
export enum DistanceUnit {
	Km = "km",
	Meter = "m",
	Mile = "mi",
	NauticalMile = "nmi",
}

export type NodeCodeType = "network" | "unlocode" | "iata" | "icao" | "wpi" | "geolocation";

export const DEFAULT_NODE_TYPE_IDS = {
	airport: 7,
	port: 6,
	centralWarehouse: 2,
	customer: 9,
	transitPoint: 4,
};

/**
 * Transport vehicle details
 */
export interface TransportVehicleDetails {
	vehicleTypeId: string;
	engineId: string;
	returnEmptyPercent: number | null;
	payloadId: string;
	averageSaturationPercent: number | null;
	ownedVehicle: boolean;
}

/**
 * Single node of the transport route
 */
export interface TransportNode {
	id: string;
	address: string;
	lat: number | null;
	lng: number | null;

	// Optional fields for detailed information
	name?: string;
	code?: string;
	codeType?: NodeCodeType;
	emissions?: number;
	nodeTypeId?: number;
	nodeTypeName?: string;
	city?: string;
	zipCode?: string;
	province?: string;
	country?: string;
	isGeolocated?: boolean;
}

/**
 * Arc between two consecutive nodes
 */
export interface TransportArc {
	id: string;
	fromNodeId: string;
	toNodeId: string;
	transportMode: TransportMode;
	networkEnabled: boolean;
	weight: number;
	weightUnit: WeightUnit;
	distance: number | null;
	distanceUnit: DistanceUnit;
	firstMileVehicle?: TransportVehicleDetails;
	mainVehicle?: TransportVehicleDetails;
	lastMileVehicle?: TransportVehicleDetails;
	useExternalMainVehicle?: boolean;
}

/**
 * Carbon Snap form data
 */
export interface CarbonSnapFormData {
	departureDate: Dayjs | null;
	numberOfTrips: number;
	weight: number;
	weightUnit: number | null;
	temperature: number | null;
	calculationMode: number | null;
	tripCode: string;
	nodes: TransportNode[];
	arcs: TransportArc[];
}
